// extracted by mini-css-extract-plugin
module.exports = {"film":"Loader_film__Yk9nP","rotate":"Loader_rotate__RDGIR","viewmaster":"Loader_viewmaster__Irlok"};